import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyWeaveLogo = lazy(() => import('./svg-components/weave-logo'));

const WeaveLogo = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyWeaveLogo {...rest} />
  </Suspense>
);

export default WeaveLogo;
